module.exports = __webpack_public_path__ + "static/media/icon-terms.848ec8a3.png";